module.exports = __webpack_public_path__ + "static/media/MTL_SL_ALCOHOL1.00843085.png";